import { useState, useEffect } from 'react'
import { useQueryClient } from 'react-query'
import Button from '../../components/buttons/button'
import Checkbox from '../../components/form/checkbox'
import { WEB_URL } from '../../constant'
import { AppName } from '../../hooks/use-title'
import useSaveConfig from '../../hooks/use-save-config'
import useLogout from '../../hooks/use-logout'
import { Trans } from 'react-i18next'
import ReactModal from 'react-modal'
ReactModal.setAppElement('#modalRoot')

const eulaUrl = `${WEB_URL}/eula/Geovonic-EULA-v6.pdf`
const iframeSrc = 'https://docs.google.com/viewer?url=' + eulaUrl + '&embedded=true'

function EulaModal ({ isOpen = false, onSuccess }) {
  const [isChecked, setIsChecked] = useState(false)
  const queryClient = useQueryClient()
  const saveAccount = useSaveConfig()
  const logout = useLogout()

  const reloadIframe = () => {
    console.log('reloading', new Date())
    const iframe = document.querySelector('iframe')
    iframe.src = iframeSrc
    checkIframe()
  }

  const checkIframe = () => {
    setTimeout(() => {
      const iframe = document.querySelector('iframe')
      try {
        const iframeDocument = iframe.contentDocument || iframe.contentWindow.document
        if (!iframeDocument?.body?.innerHTML) {
          reloadIframe()
        }
      } catch (e) {
      }
    }, 1000)
  }

  useEffect(() => {
    if (!isOpen) {
      return
    }

    checkIframe()
    /* eslint-disable-next-line */
  }, [isOpen])

  const handleAccept = async () => {
    await saveAccount.mutate({
      configType: 'EULA_FEB_24',
      data: {
        isAccepted: true
      }
    })
  }

  if (saveAccount.isSuccess) {
    setTimeout(() => {
      onSuccess(saveAccount.data)
      saveAccount.reset()
      queryClient.invalidateQueries(['action-required']) // matches key in useActionRequired
    }, 0)
  }

  return (
    <ReactModal
      isOpen={isOpen}
      overlayClassName='fixed top-0 left-0 right-0 bottom-0 p-16 bg-gray-90/50'
      className='w-[608px] h-[620px] mx-auto p-8 bg-white'
    >
      <h1 className='font-bold text-lg'>
        <Trans i18nKey='eula_modal_title' values={{ AppName }} />
      </h1>
      <a href={eulaUrl} target='_blank' className='text-sm text-purple-80 underline inline-block mt-2 mb-4' rel='noreferrer'>Download as PDF</a>
      <iframe
        src={iframeSrc}
        title='file'
        style={{ width: '100%', height: 340, border: 'solid 1px #C6C6C6' }}
      />
      <div className='flex items-start bg-purple-10 mt-4 p-3'>
        <Checkbox
          showLabel={false}
          name='acceptEula'
          onClick={e => setIsChecked(e.target.checked)}
        />
        <p className='text-xs ml-3'>
          By checking this box I confirm that I have read and agree to be bound by the {AppName} License Agreement above. If I am agreeing on behalf of my company, I represent and warrant that I have legal authority to bind my company to the terms of such Agreement above.
        </p>
      </div>
      <div className='flex space-x-4 justify-end py-4'>
        <Button
          size='sm'
          label='Cancel'
          disabled={saveAccount.isLoading}
          onClick={() => logout('/')}
        />
        <Button
          primary
          size='sm'
          label='Agree'
          isLoading={saveAccount.isLoading}
          onClick={handleAccept}
          disabled={!isChecked}
        />
      </div>
    </ReactModal>

  )
}

export default EulaModal
